import type { Keyword } from './types';

export const signalLabels: Record<string, string> = {
  striking_distance: 'Striking distance',
  low_ctr_review: 'Low CTR',
  traffic_decline: 'Traffic decline',
  page_overlap_review: 'Page overlap',
  indexability_conflict: 'Indexability conflict',
  validate_demand: 'Validate demand',
  content_gap_candidate: 'Content gap candidate',
};

export function keywordCsv(rows: Keyword[]): string {
  const cell = (value: unknown) => {
    const text = String(value ?? '');
    // Spreadsheet formula injection protection for untrusted queries and URLs.
    return `"${(/^[=+\-@\t\r\n]/.test(text) ? "'" + text : text).replaceAll('"', '""')}"`;
  };
  return [
    [
      'Keyword',
      'Source',
      'Intent',
      'Observed impressions (page aggregated)',
      'Clicks',
      'Average position',
      'Target URL',
      'Signals',
    ],
    ...rows.map((r) => [
      r.keyword,
      r.source,
      r.intent,
      r.impressions,
      r.clicks,
      r.average_position,
      r.target_url,
      r.signals.join('; '),
    ]),
  ]
    .map((row) => row.map(cell).join(','))
    .join('\r\n');
}
